import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  CustomCalendar,
  TextBtn,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { Column } from 'primereact/column'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import { tableCellCentered } from '../../../../assets/js/styles'
import { getRelacaoTransportadoraCanhoto } from '../../../../services/api/https/deliveries/delivery.http'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import { useGestaoCanhotoContext } from '../../../../contexts/EntregaContext'

function GestaoCanhoto({ history, dispatch, selectedTp }) {
  // Vars
  const context = useGestaoCanhotoContext()
  const empresasOptions = getEmpresas()
  const cache = context.gestaoCanhotoContext.principal
  const restaurar = !!(cache && cache.restaurarAoVoltar)

  // Hooks
  const [empresa, setEmpresa] = useState(restaurar ? cache.empresa : null)
  const [canhotos, setCanhotos] = useState(restaurar ? cache.canhotos : [])
  const [pInicial, setPeriodoInicial] = useState(
    restaurar ? cache.pInicial : context.gestaoCanhotoContext.selectedPeriodo.dataInicial,
  )
  const [pFinal, setPeriodoFinal] = useState(
    restaurar ? cache.pFinal : context.gestaoCanhotoContext.selectedPeriodo.dataFinal,
  )

  useEffect(() => {
    if (restaurar) {
      context.setGestaoCanhotoContext(prev => ({ ...prev, principal: null }))
    }
  }, [])

  // Helpers
  const fetchEntregasPorEmpresa = async (empresa, pInicial, pFinal) => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico')
      if (!empresa) throw new Error('Selecione a Empresa')
      dispatch(showLoadingBox('Carregando os canhotos', 'Aguarde . . .'))

      const canhotos = await getRelacaoTransportadoraCanhoto(
        selectedTp,
        parseToMysqlFormat(pInicial),
        parseToMysqlFormat(pFinal),
        empresa.id,
      )

      setCanhotos(canhotos)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onPeriodoChange = (campo, value) => {
    context.setGestaoCanhotoContext(prev => ({
      ...prev,
      selectedPeriodo: { ...prev.selectedPeriodo, [campo]: value },
    }))
    if (campo === 'dataInicial') setPeriodoInicial(value)
    else setPeriodoFinal(value)
  }

  const onRowClick = (path, e, pInicial, pFinal) => {
    context.setGestaoCanhotoContext(prev => ({
      ...prev,
      principal: { restaurarAoVoltar: true, empresa, canhotos, pInicial, pFinal },
    }))
    history.push(path, {
      transportadora_id: e.transportadora_id ? e.transportadora_id : null,
      dataInicial: parseToMysqlFormat(pInicial),
      dataFinal: parseToMysqlFormat(pFinal),
      transportadora: e.transportadora,
      company_id: empresa.id,
      empresa: empresa.name,
    })
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>3.17 - Gestão de Canhotos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                label="Empresa"
                optionLabel="name"
                options={empresasOptions}
                value={empresa}
                onChange={setEmpresa}
                placeholder="Selecione a empresa"
                filter={true}
              />
            </div>
            <div className="p-col-9" style={{ display: 'flex' }}>
              <CustomCalendar
                label="Período Inicial"
                value={pInicial}
                onChange={value => onPeriodoChange('dataInicial', value)}
              />
              <CustomCalendar
                label="Período Final"
                value={pFinal}
                onChange={value => onPeriodoChange('dataFinal', value)}
              />
              <div style={{ marginLeft: 10, paddingTop: 27 }}>
                <Btn onClick={() => fetchEntregasPorEmpresa(empresa, pInicial, pFinal)}>
                  Pesquisar
                </Btn>
              </div>
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <CanhotosDataTable
              canhotos={canhotos}
              onRowClick={(path, transportadora) =>
                onRowClick(path, transportadora, pInicial, pFinal)
              }
            />
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

function CanhotosDataTable({ canhotos, onRowClick }) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Render
  return (
    <DataTable
      value={canhotos}
      emptyMessage="Nenhuma informação foi encontrada"
      header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      rows={20}
      paginator={true}
    >
      <Column field="transportadora" header="Transportadora" />
      <Column field="qte_entregas" header="Qte. Entregas" style={tableCellCentered()} />
      <Column
        field="qte_sem_canhoto"
        header="Qte. Sem Canhoto"
        style={tableCellCentered()}
        body={canhoto => (
          <TextBtn
            onClick={() => onRowClick('/main/entregas/gestao-canhotos-sem-canhoto', canhoto)}
          >
            {canhoto.qte_sem_canhoto}
          </TextBtn>
        )}
      />
      <Column
        field="qte_com_canhoto"
        header="Qte. Com Canhoto"
        style={tableCellCentered()}
        body={canhoto => (
          <TextBtn
            onClick={() => onRowClick('/main/entregas/gestao-canhotos-com-canhoto', canhoto)}
          >
            {canhoto.qte_com_canhoto}
          </TextBtn>
        )}
      />
      <Column
        field="percentual_sem_canhoto"
        header="% Sem Canhoto"
        style={tableCellCentered()}
        body={canhoto => `${canhoto.percentual_sem_canhoto.toFixed(2)}%`}
      />
      <Column
        field="percentual_com_canhoto"
        header="% Com Canhoto"
        style={tableCellCentered()}
        body={canhoto => `${canhoto.percentual_com_canhoto.toFixed(2)}%`}
      />
    </DataTable>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(GestaoCanhoto))
